// src/data/offersTravel.js
const baseImagePath = process.env.REACT_APP_BASE_IMAGE_PATH;

const offers = [
  {
    id: "t1",
    category: "",
    country: "Österreich",
    title: "Klettern Pinzgau",
    subtitle:
      "Ein kletternder Erkundungstrip der nördlichen Kalkalpen und Hohen Tauern.",
    text_overview:
      "Dich erwarten zwei Klettertouren in beeindruckender Landschaft, eine im besten Salzburger Kalk und eine im Urgestein der Hohen Tauern. Die Länge, Steilheit und Exposition werden individuell abgestimmt.",
    text_itinerary:
      "Tag 1: Alpinklettern Kalkalpen. Der erste Tag ist sehr vom reinen Kletterniveau der TeilnehmerInnen abhängig. Klar ist, dass wir das Richtige finden werden, der Pinzgau ist ein unterschätztes Juwel des Alpin- und Sportkletterns. Wenn man der Einsamkeit willen ein wenig Zustieg nicht scheut wird man in den Loferer- und Leoganger Steinbergen und der Reiteralpe immer fündig. Je nach Kletterkönnen und Kondition können wir aus dem Zustieg schon eine kleine Entdeckerreise machen und am Schluss als Krönung einen Gipfel erklettern. Oder wir verkürzen den Zustieg und und konzentrieren uns auf eine höhere, steilere Wand. Untergebracht sind wir in einem einfachen Appartementhaus in Saalbach, hier folgt noch der Materialcheck für den nächsten Tag. Tag 2: Alpinklettern Hohe Tauern. Wir sind am ersten Tag bestimmt schon viel gewandert, weshalb wir uns in den Hohen Tauern ein leicht zugängliches aber dennoch wenig besuchtes Kletterziel suchen. Fündig werden wir am Weißsee, wo wir nach Auffahrt mit der Gondel nur noch etwa eine Stunde Fußmarsch hinter uns bringen müssen um vor einem kleinen Klettermekka zu stehen. Aufgebaut aus bestem Urgestein warten hier kürzere und längere Routen in den mittleren Schwierigkeitsgraden.",
    price: "ab € 1.200,00",
    prices: {
      1: "1.200,00",
      2: "1.300,00",
    },
    inclServices: [
      "Führung durch staatlich geprüften Bergführer",
      "Leihausrüstung nach Bedarf",
      "Übernachtung im Appartementhaus",
    ],
    exclServices: [
      "Fahrtkosten",
      "Liftkarte falls benötigt",
      "verbilligte Liftkarte des Bergführers",
    ],
    equipment: "Kletterschuhe",
    date: "Nach Absprache.",
    duration: "2 Tage",
    place: "Pinzgau, Salzburg",
    maxGuests: "2",
    overalleLevel: 3,
    levelTech: 33,
    levelTechText: "Erfahrung im Klettern von Mehrseillängenrouten",
    levelFitness: 22,
    levelFitnessText: "Lange Wanderung mit leichtem Gepäck",
    link: "/travel",
    displayHome: false,

    imgHead: `${baseImagePath}travel/offers/t1_Pinzgau_klettern/head.jpg`,
    imgOne: `${baseImagePath}travel/offers/t1_Pinzgau_klettern/pinzClimb1.jpg`,
    imgTwo: `${baseImagePath}travel/offers/t1_Pinzgau_klettern/pinzClimb3.jpg`,
    imgThree: `${baseImagePath}travel/offers/t1_Pinzgau_klettern/pinzGipfel.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },

  {
    id: "t2",
    category: "",
    country: "Österreich",
    title: "Glockner mit Vorbereitung",
    subtitle:
      "Der Tauernkönig Großglockner als Ziel für verbessertes Eigenkönnen.",
    text_overview:
      "Sei es weil ihr euch nicht ganz sicher seid ob der Glocker schon drinnen ist oder weil ihr euch besser vorbereiten und ein wenig mehr Verantwortung übernehmen wollt: Bei einer kurzen Vorbereitungstour klären wir das ab. Am folgenden Tag nehmen wir den Großglockner in Angriff oder wählen ein passendes Alternativziel.",
    text_itinerary:
      "Tag 1: Wir treffen uns am Nachmittag auf einer der Almen im Pinzgau und klettern 2-3 Stunden gemütlich in wenig exponiertem Gelände, welches jedoch alle Fragen aufwirft die wir für den Glockner beantworten müssen. Themen sind Sichern im Vor- und Nachstieg, Sichern und Bewegen am Grat, Ablauf einer Seilschaft privat und im Führungskontext. Wir kehren in einer der Almen ein und machen unsere Tourenplanung für die folgenden zwei Tage. Untergebracht sind wir in einem einfachen Appartementhaus in Saalbach. Tag 2: In der Früh Materialcheck und Rucksackpacken, im Appartement ist genug Platz um sich auszubreiten und wir können bequem fehlende Ausrüstung ergänzen. Anfahrt nach Matrei und zum Lucknerhaus, gemeinsamer Aufstieg zur Adlersruhe, der genial gelegenen höchsten Schutzhütte Österreichs. Je nach Lust und Laune haben wir heute noch genug Zeit für Themenbesprechung Gletscher und eine Orientierungseinheit. Tag 3: Gipfeltag mit Sonnenaufgang am Gletscher. Der Gipfel ist von der Adlersruhe aus in relativ kurzer Zeit erreichbar (2 h), wir bewegen uns aber durchwegs in spannendem und variablem Gelände. Die Zeit die der Kontakt mit anderen Seilschaften braucht nützen wir entspannt für Fotos und Tiefblicke. Ebenso ausgesetzt geht es auf gleichem Weg zurück zur Adlersruhe und zur Stüdlhütte, wo wir uns bei einem Getränk verabschieden.",
    price: "ab € 1.350,00",
    prices: {
      1: "1.350,00",
      2: "1.450,00",
    },
    inclServices: [
      "Führung durch staatlich geprüften Bergführer",
      "Unterweisung in Themen von Interesse",
      "Leihausrüstung nach Bedarf",
      "Übernachtung im Appartementhaus",
      "Übernachtung und Halbpension Adlersruhe",
    ],
    exclServices: [
      "Verpflegung im Appartementhaus",
      "Maut",
      "Park- und Fahrtkosten",
    ],
    equipment: "Kletterschuhe",
    date: "Nach Absprache.",
    duration: "3 Tage",
    place: "Glocknergruppe, Hohe Tauern",
    maxGuests: "2",
    overalleLevel: 3,
    levelTech: 22,
    levelTechText: "Trittsicherheit",
    levelFitness: 33,
    levelFitnessText: "Hochtour mit Übernachtung",
    link: "/travel",
    displayHome: false,

    imgHead: `${baseImagePath}travel/offers/t2_Glockner_Vorbereitung/head.jpg`,
    imgOne: `${baseImagePath}travel/offers/t2_Glockner_Vorbereitung/IMG_1412.jpg`,
    imgTwo: `${baseImagePath}travel/offers/t2_Glockner_Vorbereitung/IMG_6353.jpg`,
    imgThree: `${baseImagePath}travel/offers/t2_Glockner_Vorbereitung/IMG_6364.jpg`,

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  },

  {
    id: "t3",
    category: "",
    country: "Spanien",
    title: "Climb & Dive Mallorca",
    subtitle: "Hoch hinaus & tief hinab – Dein ultimatives Outdoor-Erlebnis!",
    text_overview:
      "Erlebe ein einzigartiges Abenteuer auf Mallorca, das Klettern, Tauchen und Entdeckungen vereint! Je nach Kletterkönnen erwarten dich spannende Sportkletter- und Mehrseillängen-Routen an den beeindruckendsten Felsen der Insel. Eine perfekte Kombination aus Action, Natur und Entspannung!",
    text_itinerary:
      "Tag 1: Ankommen auf Mallorca, gemeinsames Anstoßen beim ersten Abendessen und Vorbesprechung der Kletterwoche. Tag 2: Einführung ins Sportklettern mit Equipment-Check, Einschätzung des Kletterkönnens und Training der Seilschaftsabläufe. Tag 3: Gruppe 1 geht in die Mehrseillängen-Klettertour, während Gruppe 2 sich dem Tauchen oder Wassersport widmet. Tag 4: Wechsel der Aktivitäten – Gruppe 2 klettert Mehrseillängen, Gruppe 1 genießt Tauchen oder Wassersport. Tag 5: Erholungstag mit optionalem City-Trip, kulturellen Ausflügen oder einem entspannten Tag am Meer. Tag 6: Flexibler Programmtag – Je nach Lust und Wetter geht es zum Mehrseillängen-Klettern, zum Spot-Wechsel beim Sportklettern oder zum Tauchen. Tag 7: Individuelle Abreise.",
    price: "ab € 1.440,00",
    prices: {
      1: "1.440,00",
      2: "2.880,00",
      3: "4.320,00",
      4: "5.760,00", 
    },
    inclServices: [
      "Führung und Klettertraining durch staatlich geprüften Bergführer",
      "Unterkunft inkl. Frühstück",
      "Transfer zu den Kletter- und Tauchspots",
      "City Trip am Pausentag",
      "2 Tauchgänge inkl Guide und Equipment pro Person",
    ],
    exclServices: [
      "Eigene An- und Abreise",
      "Kletterausrüstung",
      "Verpflegung",
      "alle Aktivitäten außerhalb des Programms",
    ],
    equipment:
      "Kletterausrüstung (Schuhe, Gurt und Sicherungsgerät wenn vorhanden)",
    date: "",
    duration: "6 Nächte/7 Tage",
    place: "Mallorca",
    maxGuests: "8",
    minGuests: "7",
    overalleLevel: 2,
    levelTech: 22,
    levelTechText: "erste Klettererfahrungen sind vorhanden",
    levelFitness: 22,
    levelFitnessText:
      "längere leichte Routen können im Nachstieg absolviert werden",
    link: "/travel",
    displayHome: true,

    imgHead: `${baseImagePath}travel/offers/t3_climbAndDiveMallorca/head.jpg`,
    imgOne: `${baseImagePath}travel/offers/t3_climbAndDiveMallorca/climb1.JPG`,
    imgTwo: `${baseImagePath}travel/offers/t3_climbAndDiveMallorca/crag1.JPG`,
    imgThree: `${baseImagePath}travel/offers/t3_climbAndDiveMallorca/cultur1.jpg`,
    imgFour: `${baseImagePath}travel/offers/t3_climbAndDiveMallorca/climb2.JPG`,

    descrImgOne: "Klettern Mallorca",
    descrImgTwo: "Klettergebiete Mallorca",
    descrImgThree: "Sehenswürdigkeit",
    descrImgFour: "Überhängend klettern auf Mallorca",
  },

  {
    id: "t4",
    category: "",
    country: "Bosnien",
    title: "Klettern im wilden Herz Europas ",
    subtitle: "Entdecke Bosnien zwischen Fels und Geschichte",
    text_overview: "Diese Kletterreise verbindet sportliche Herausforderungen mit kulturellen Highlights. Wir starten in Sarajevo und erkunden die Kletterspots rund um die Stadt. Nach einem intensiven Start geht es nach Pecka, ein Paradies für Sportkletterer inmitten unberührter Natur. Zum Abschluss erwartet uns der sonnige Süden: Mostar und die beeindruckenden Felsen von Blagaj.", 
    text_itinerary: " Tag 1: Individuelle Anreise nach Sarajevo und gemeinsames Abendessen in der Altstadt. Kennenlernen der Gruppe und Vorstellung des Programms. Tag 2: Wir starten unsere Reise mit einem halben Tag am Fels – die ersten Kletterrouten warten direkt vor den Toren Sarajevos auf uns. Am Nachmittag lassen wir die Kletterschuhe stehen und tauchen bei einer Stadtführung in die Geschichte und das bunte Leben dieser faszinierenden Stadt ein. Tag 3: Fahrt nach Pecka (ca. 3,5 Stunden). Ankunft am frühen Nachmittag und direkt weiter zu den ersten Seillängen am Fels. Die ruhige Lage, das Kalkgestein und die Naturkulisse machen Pecka zu einem echten Geheimtipp. Tag 4: Ein ganzer Tag Klettern in Pecka – ob Genussrouten, steile Wände oder neue Projekte: Die Region bietet für jedes Niveau spannende Herausforderungen. Abends gemeinsames Essen und Entspannung in der Unterkunft. Tag 5: Fahrt in den Süden nach Mostar. Wer möchte kann eine Stadtbesichtigung unternehmen mit Altstadtflair, Brückenspringer und Kaffee am Fluss – ein Kontrastprogramm zur Felswand. Tag 6: Klettern in Blagaj, direkt über dem türkisblauen Fluss. Die beeindruckende Kulisse und sonnige Ausrichtung der Wände machen diesen Spot zu einem Highlight der Reise. Tag 7: Rückfahrt nach Sarajevo und individuelle Abreise.",
    price: "ab € 1.077,00",
    prices: {
      1: "1.077,00",
      2: "2.154,00",
      3: "3.231,00",
      4: "4.308,00", 
    },
    inclServices: [
      "Führung und Klettertraining durch staatlich geprüften Bergführer",
      "Unterkunft inkl. Frühstück",
      "Transfer zu den Kletterplätzen, Städten und Unterkünften",
      "Stadtführung in Sarajevo",
],
    exclServices: [
      "Eigene An- und Abreise",
      "Kletterausrüstung",
      "Verpflegung",
      "alle Aktivitäten außerhalb des Programms",
    ],
    equipment:
      "Kletterausrüstung (Schuhe, Gurt und Sicherungsgerät wenn vorhanden)",
    date: "",
    duration: "6 Nächte/7 Tage",
    place: "Bosnien-Herzegowina",
    maxGuests: "6",
    minGuests: "5",
    overalleLevel: 2,
    levelTech: 22,
    levelTechText: "erste Klettererfahrungen sind vorhanden",
    levelFitness: 22,
    levelFitnessText:
      "längere leichte Routen können im Nachstieg absolviert werden",
    link: "/travel",
    displayHome: true,

    imgHead: `${baseImagePath}travel/offers/t4_climbBosnia/Blagaj.jpg`,
    imgOne: `${baseImagePath}travel/offers/t4_climbBosnia/BlagajCulture.jpg`,
    imgTwo: `${baseImagePath}travel/offers/t4_climbBosnia/BlagajRebro.jpg`,
    imgThree: `${baseImagePath}travel/offers/t4_climbBosnia/Mostar.jpg`,
    imgFour: `${baseImagePath}travel/offers/t4_climbBosnia/PeckaClimbing.jpg`,
    imgFive: `${baseImagePath}travel/offers/t4_climbBosnia/WayToPecka.jpg`,

    descrImgOne: "Blagaj Umgebung",
    descrImgTwo: "Klettersektor Rebro",
    descrImgThree: "Mostar",
    descrImgFour: "Klettern in Pecka",
    descrImgFive: "Auf dem Weg nach Pecka",
  }
];

export default offers;

/* 
 {
  {
    id: "a1",
    category: "",
    country: "", 
    title: "",
    subtitle: "",
    text_overview: "", 
    text_itinerary: "",
    price: "ab € 000,00",
    prices: {
      1: 750, 
      2: 900  
    },
    inclServices: [], 
    exclServices: [],
    equipment: "",
    date: "",
    duration: "",
    place: "",
    maxGuests: "",
    minGuests: "",
    overalleLevel: ,
    levelTech: ,
    levelTechText: "",
    levelFitness: ,
    levelFitnessText: "",
    link: "/mountainguide",
    displayHome: true,

    imgHead: `${baseImagePath}mountainguide/offers/m1_Traunspitzl_Neue_Zeiten/IMG_7534_head.jpg`,
    imgOne: '',
    imgTwo: '',
    imgThree: '',

    descrImgOne: "",
    descrImgTwo: "",
    descrImgThree: "",
  
  }
  */
